import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBodyText,
  FDBox,
  FDStack,
  FDTable,
  FDTableBody,
  FDTableCell,
  FDTableHead,
  FDTableRow,
} from '@facet-wealth/design';
import HoldingsBarChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/BalanceAndAllocationTabPanelLayout/HoldingsBarChart/HoldingBarChart';
import { USDCurrencyFullFormatter } from 'Helpers/Formats';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import useMobileLayout from 'Hooks/useMobileLayout';
import HoldingCard from 'Components/UI/HoldingCard/HoldingCard';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import {
  useManagedAccountPortfolio,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/BalanceAndAllocationTabPanelLayout/useManagedAccountPortfolio';
import { dataAttrs } from 'Helpers/Testing';

export default function ManagedAccountPortfolioLegacy({ portfolio }) {
  const isMobile = useMobileLayout();
  const { logPortfolioChart, logHoldingsTable } = useManagedAccountPageEventLogger();

  const {
    selectedCategory,
    setSelectedCategory,
    categories,
    filteredCategories,
    filteredHoldings,
    usingMockData,
  } = useManagedAccountPortfolio(portfolio);

  if (!filteredHoldings?.length) return <FDBox><FDBodyText value={'No Account Holdings'} /></FDBox>;

  return (
    <>
      <FDStack direction={isMobile ? 'column' : 'row'} spacing={2}>
        <FDStack direction={isMobile ? 'column' : 'row'} width={isMobile ? '100%' : '30%'} {...dataAttrs('managed-account-allocation-distribution')}>
          <HoldingsBarChart
            data={categories}
            disable={usingMockData}
            onSectionClick={(label) => {
              logPortfolioChart(`Set Category ${label === selectedCategory ? 'All' : label}`);
              setSelectedCategory(label === selectedCategory ? null : label);
            }}
            selectedSection={selectedCategory}
          />
        </FDStack>
        <FDBox width={isMobile ? '100%' : '70%'} {...dataAttrs('managed-account-allocation-holdings')}>
          {isMobile
            ? filteredHoldings.map(({ holding, category }) => (
              <HoldingCard
                key={holding.id()}
                holdingResource={holding}
                holdingClassificationColor={category.color}
                expandedByDefault={filteredCategories.length === 1}
              />
            )) : null
          }

          {!isMobile
            ? (
              <FDTable>
                <FDTableHead>
                  <FDTableRow>
                    <FDTableCell>{'Symbol'}</FDTableCell>
                    <FDTableCell align={'right'}>{'Quantity'}</FDTableCell>
                    <FDTableCell align={'right'}>{'Price'}</FDTableCell>
                    <FDTableCell align={'right'}>{'Value'}</FDTableCell>
                    <FDTableCell align={'right'}>{'Cost Basis'}</FDTableCell>
                    <FDTableCell align={'right'}>{'Gain/Loss'}</FDTableCell>
                  </FDTableRow>
                </FDTableHead>
                <FDTableBody>
                  {filteredHoldings.map(({ holding, category }) => (
                    <FDTableRow key={holding.id()} onClick={() => logHoldingsTable(`Holding for category ${category.label}`)} hover>
                      <FDTableCell>
                        <FDStack direction={'row'} alignItems={'center'}>
                          <FiberManualRecordIcon style={{ color: category.color }} onClick={() => logHoldingsTable(`Color icon for category ${category.label}`)} />
                          {holding.attr('ticker')}
                        </FDStack>
                      </FDTableCell>
                      <FDTableCell align={'right'}>{holding.attr('quantity')}</FDTableCell>
                      <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('currentPrice'))}</FDTableCell>
                      <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('currentValue'))}</FDTableCell>
                      <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('costBasis'))}</FDTableCell>
                      <FDTableCell align={'right'}>{USDCurrencyFullFormatter.format(holding.attr('dollarGain'))}</FDTableCell>
                    </FDTableRow>
                  ))}
                </FDTableBody>
              </FDTable>
            ) : null}
        </FDBox>
      </FDStack>
    </>
  );
}
ManagedAccountPortfolioLegacy.defaultProps = {
  portfolio: undefined,
};
ManagedAccountPortfolioLegacy.propTypes = {
  portfolio: PropTypes.instanceOf(fr.Resource),
};
